import { useSortingQueryParam, UseSortingReturn } from "@hooks/table-sort/use-sorting-query-param";
import { useEffect, useState } from "react";

export interface SubjectsSortByQueryParams<T extends string> {
/** Default sort value to use when no valid parameter is found */
  defaultSort : T;
  
  /** Type guard function to validate if a value is a valid sort option */
 isValidSort : (value: string | null) => value is T;
}

/** Hook to manage the subjects sortBy query parameter */
export function useSubjectsSortByQuery<T extends string>(options : SubjectsSortByQueryParams<T>): UseSortingReturn<T> {
  const { sortBy: newSortBy, setSortBy: setNewSortBy } = useSortingQueryParam<T>({
    defaultSort: options.defaultSort,
    isValidSort: options.isValidSort,
  });
  const [cachedSortBy, setCachedSortBy] = useState<T>(newSortBy);

  // Caches the sortBy value to avoid unnecessary re-renders
  useEffect(() => {
    if (newSortBy !== cachedSortBy) {
      setCachedSortBy(newSortBy);
    }
  }, [newSortBy, cachedSortBy]);

  return {
    sortBy: cachedSortBy,
    setSortBy: setNewSortBy,
  };
}
